export default __webpack_public_path__ + "static/pottery-gang-f54948da9e02375de5929d979bd5a95c.webp";